import { FC, HTMLAttributes, useMemo } from 'react'
import css from 'styled-jsx/css'
import { isValidTimeToEnableShopHelp } from '@ui/helpers'
import ShopHelpLogo from '../ShopHelp/ShopHelpLogo'
import { useIsShowShophelp } from '@ui/hooks'

interface IServeByShopHelp extends HTMLAttributes<HTMLDivElement> {
  type?: 'desktop' | 'mobile'
}

const ServeByShopHelp: FC<IServeByShopHelp> = ({ className }) => {
  const isShowShophelp = useIsShowShophelp()

  const promotionShopHelp = useMemo(() => isShowShophelp && isValidTimeToEnableShopHelp(), [
    isShowShophelp
  ])

  return (
    <>
      <style jsx>{style}</style>
      {promotionShopHelp && (
        <div className="non-bg">
          <span className={`servedby-shophelp ${className ?? ''}`}>
            <span className="is-flex">
              Served by <ShopHelpLogo className="ml-2" height={92} width={150} />
            </span>
          </span>
        </div>
      )}
    </>
  )
}

const style = css`
  .non-bg {
    background-color: #ffffff;
  }

  .servedby-shophelp {
    span {
      font-size: 15px;
      line-height: 32px;
      align-items: center;
      justify-content: center;
      color: var(--text);
    }
  }
`

export default ServeByShopHelp
